import styles from 'styles/modules/mediaCoverage/CoveragePreview.module.scss';
import Typo from 'components/Typo';

const CoveragePreview = ({
    isLoaded,
    isEditable,
    source,
    title,
    body,
    isUrlEmpty,
}) => {
    const isTitleAndBodyEmpty = !title && !body;

    return (
        <div className={['border-gray', styles.item].join(' ')}>
            {isLoaded || isEditable ? (
                isTitleAndBodyEmpty ? (
                    <div className={styles.errorMessage}>
                        <Typo variant={'small'}>
                            There was an error getting data from this page. This
                            will need to be done manually.
                        </Typo>
                    </div>
                ) : (
                    <>
                        <Typo variant={'special'} className={'mb-xs'}>
                            {source}
                        </Typo>
                        <Typo
                            variant={'caption'}
                            className={['mb-xxxs', styles.title].join(' ')}
                        >
                            {title}
                        </Typo>
                        <Typo variant={'small'} className={styles.body}>
                            {body}
                        </Typo>
                    </>
                )
            ) : (
                isUrlEmpty && (
                    <div className={styles.loaderWrapper}>
                        <div className={styles.loader} />
                        <Typo variant={'small'} className={'mt-xxs'}>
                            generating <br /> preview
                        </Typo>
                    </div>
                )
            )}
        </div>
    );
};

export default CoveragePreview;
